export const OktaClientId = '0oa6avxblwc5lrjm2697'
export const ENV = 'lab-pp' as string
export const OVERSIGHT_ENV_NAME = 'oversight-lab'
export const GCS_ENV_NAME = 'lab-pp'
export const SUBDOMAIN_SUFFIX = 'gcs-lab'
